import React from 'react';

import styled from 'styled-components';
import copy from 'copy-to-clipboard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import { func, string, bool } from 'prop-types';

import Status from './Status';
import Theme from '../theme/Theme';
import { WhiteCard } from './WhiteCard';
import {
  CompanyDefaultUser,
  ArrowUpIcon,
  ArrowDownIcon,
} from '../theme/images';

const TableMobileView = ({
  className,
  CompanyName,
  invoiceType,
  invoiceId,
  label,
  statusLabelColor,
  labelInfo,
  label1,
  label2,
  label3,
  label4,
  label5,
  label6,
  label7,
  label8,
  labelInfo1,
  sublabel,
  sublabel1,
  labelInfo2,
  labelInfo3,
  labelInfo4,
  labelInfo5,
  labelInfo6,
  labelInfo7,
  labelInfo8,
  status,
  statusColor,
  onClick,
  icon,
  marketplaces,
  isColumnOnClick = false,
  isShowCopyIcon = false,
  onColumnClick,
  mainLabel,
  isShowPercentage,
  isLabelInfo2Positive,
  isLabelInfo5Positive,
  isBBEDashboard,
  isInventory = false,
  isCancelRequest = false,
  copyText = '',
  showBorder,
  statusIcon,
  iconAfterLabel = false,
}) => {
  const col = `${
    label3 ? (label7 ? 'col-4' : 'col-6') : showBorder ? 'col-6' : 'col-4'
  }`;

  const renderTableView = () => {
    return (
      <>
        <div className="row">
          {CompanyName ||
          CompanyDefaultUser ||
          invoiceType ||
          invoiceId ||
          CompanyDefaultUser ||
          mainLabel ? (
            <div className="col-7 pr-0">
              {CompanyName ? (
                <>
                  <img
                    className="company-logo"
                    src={icon || CompanyDefaultUser}
                    alt="logo"
                  />
                  <div className="CompanyName">{CompanyName}</div>
                  {invoiceType !== null ? (
                    <div className="CompanyName">{invoiceType}</div>
                  ) : null}
                  {invoiceId ? (
                    <div className="CompanyId">{`${invoiceId}`}</div>
                  ) : null}
                </>
              ) : (
                <>
                  {mainLabel ? (
                    <div className="CompanyName LargeCompanyName">
                      {mainLabel}
                    </div>
                  ) : invoiceType ? (
                    <>
                      <div
                        className={`CompanyName ${
                          !isBBEDashboard ? 'LargeCompanyName' : null
                        }`}
                      >
                        {invoiceType}
                        {isShowCopyIcon ? (
                          <FontAwesomeIcon
                            className="pl-2 cursor"
                            icon="fa-light fa-copy"
                            style={{ color: '#ff4817' }}
                            onClick={() => {
                              copy(copyText);
                              toast.success('copied');
                            }}
                          />
                        ) : null}
                      </div>
                      <div className="CompanyId">
                        {invoiceId ? `${invoiceId}` : null}
                        {marketplaces}
                      </div>
                    </>
                  ) : null}
                </>
              )}
            </div>
          ) : null}

          {status ? (
            <div className="col-5 text-right">
              {' '}
              <Status
                className="card-staus-right"
                label={status}
                backgroundColor={statusColor}
                labelColor={statusLabelColor}
                iconAfterLabel={iconAfterLabel}
                fontIcon={statusIcon || null}
              />
              <div className="clear-fix" />
            </div>
          ) : null}
        </div>
        {!isInventory && !showBorder ? (
          <div className="straight-line horizontal-line mb-3 mt-2" />
        ) : null}

        <div className="row">
          <div className={`${col} mb-3`}>
            {' '}
            <div className="label">{label}</div>
            <div className="label-info label-bold"> {labelInfo}</div>
            {sublabel && (
              <div
                className={
                  sublabel === 'Ongoing' ||
                  invoiceType === 'One-Time' ||
                  invoiceType === 'Pause'
                    ? 'sub-label-text'
                    : 'label-info label-bold'
                }
              >
                {sublabel}
              </div>
            )}
          </div>
          <div className={`${col} mb-3`}>
            {' '}
            <div className="label">{label1}</div>
            <div className="label-info label-bold"> {labelInfo1}</div>
            {sublabel1 && <div className="sub-label-text">{sublabel1}</div>}
          </div>
          <div className={`${col} mb-3`}>
            {' '}
            <div className="label">{label2}</div>
            {isCancelRequest ? (
              <ul className="pending-status  ">
                <li>
                  <p
                    className="orange-text-label cursor"
                    role="presentation"
                    onClick={
                      isColumnOnClick ? () => onColumnClick('cancel') : null
                    }
                  >
                    Cancel
                  </p>
                </li>

                <li className="divide-gap" />

                <li>
                  <p
                    className="orange-text-label cursor"
                    role="presentation"
                    onClick={
                      isColumnOnClick ? () => onColumnClick('view') : null
                    }
                  >
                    {' '}
                    View
                  </p>
                </li>
              </ul>
            ) : null}
            {isColumnOnClick && !isCancelRequest ? (
              <p
                className="orange-text-label cursor"
                role="presentation"
                onClick={() => onColumnClick('view')}
              >
                {' '}
                View
              </p>
            ) : null}
            {!isCancelRequest && !isColumnOnClick ? (
              <div
                role="presentation"
                className={
                  isShowPercentage
                    ? `label-info ${
                        isLabelInfo2Positive ? 'increase-rate' : 'decrease-rate'
                      }`
                    : 'label-info'
                }
              >
                {' '}
                {isShowPercentage ? (
                  <img
                    className={
                      isLabelInfo2Positive ? 'green-arrow' : 'red-arrow'
                    }
                    src={isLabelInfo2Positive ? ArrowUpIcon : ArrowDownIcon}
                    alt="arrow-up"
                  />
                ) : null}
                {labelInfo2}
              </div>
            ) : null}
          </div>

          {label3 ? (
            <div className={`${col} mb-3`}>
              {' '}
              <div className="label">{label3}</div>
              <div className="label-info "> {labelInfo3}</div>
            </div>
          ) : null}
          {isInventory ? (
            <div className={`${col} mb-3`}>
              {' '}
              <div className="label">{label4}</div>
              <div className="label-info "> {labelInfo4}</div>
            </div>
          ) : null}
          {isInventory ? (
            <div className={`${col} mb-3`}>
              {' '}
              <div className="label">{label5}</div>
              {labelInfo5 !== 'N/A' && labelInfo5 !== '0%' ? (
                <div
                  role="presentation"
                  className={`label-info ${
                    isLabelInfo5Positive ? 'increase-rate' : 'decrease-rate'
                  }`}
                >
                  {' '}
                  <img
                    className={
                      isLabelInfo5Positive ? 'green-arrow' : 'red-arrow'
                    }
                    src={isLabelInfo5Positive ? ArrowUpIcon : ArrowDownIcon}
                    alt="arrow-up"
                  />
                  {labelInfo5}
                </div>
              ) : (
                <div
                  className={`label-info ${
                    labelInfo5 === '0%' ? 'gray80' : ''
                  }`}
                >
                  {' '}
                  {labelInfo5}
                </div>
              )}
            </div>
          ) : null}
          {(label7 ||
            label3 ||
            label4 ||
            label5 ||
            label6 ||
            label7 ||
            label8) &&
          !isInventory ? (
            <>
              {label4 ? (
                <div className={`${col} mb-3`}>
                  {' '}
                  <div className="label">{label4}</div>
                  <div className="label-info "> {labelInfo4}</div>
                </div>
              ) : null}
              {label5 ? (
                <div className={`${col} mb-3`}>
                  {' '}
                  <div className="label">{label5}</div>
                  <div className="label-info "> {labelInfo5}</div>
                </div>
              ) : null}
              {label6 ? (
                <div className={`${col} mb-3`}>
                  {' '}
                  <div className="label">{label6}</div>
                  <div className="label-info "> {labelInfo6}</div>
                </div>
              ) : null}
              {label7 ? (
                <div className={`${col} mb-3`}>
                  {' '}
                  <div className="label">{label7}</div>
                  <div className="label-info "> {labelInfo7}</div>
                </div>
              ) : null}
              {label8 ? (
                <div className={`${col} mb-3`}>
                  {' '}
                  <div className="label">{label8}</div>
                  <div className="label-info "> {labelInfo8}</div>
                </div>
              ) : null}
            </>
          ) : null}
        </div>
      </>
    );
  };
  return (
    <TableMobileViewWrapper className={[className]} onClick={onClick}>
      <WhiteCard className={showBorder ? 'p-0' : null}>
        {showBorder ? (
          <fieldset className="shape-without-border">
            {renderTableView()}
          </fieldset>
        ) : (
          renderTableView()
        )}
      </WhiteCard>
    </TableMobileViewWrapper>
  );
};

export default TableMobileView;

const TableMobileViewWrapper = styled.div`
  .company-logo {
    border-radius: 10px;
    width: 47px;
    height: 47px;
    margin-bottom: 8px;
    float: left;
    margin-right: 14px;
    clear: both;
  }
  /* .pending-status {
    list-style-type: none;
    padding: 0;
    margin: 0;
    text-align: end;

    li {
      display: inline-block;
      margin-left: 10px;

      &:first-child {
        margin-left: 0;
      }

      &.divide-gap {
        border-right: 1px solid #bfc5d2;
        width: 2px;
        height: 12px;
      }
    }
  } */

  .CompanyName {
    vertical-align: middle;
    position: relative;
    color: ${Theme.black};
    font-size: ${Theme.extraNormal};
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 270px;
    min-height: 20px;
    margin-top: 5px;
    text-transform: capitalize;

    &.LargeCompanyName {
      font-size: ${Theme.title};
      margin-bottom: 10px;
    }
  }
  .CompanyId {
    font-size: ${Theme.extraNormal};
    color: ${Theme.gray85};
  }

  .card-staus-right {
    float: right;
  }

  .label-bold {
    font-weight: bold;
  }
  .sub-label-text {
    font-size: ${Theme.extraNormal};
    color: ${Theme.black};
  }
`;

TableMobileView.defaultProps = {
  isColumnOnClick: false,
  isShowCopyIcon: false,
  isShowPercentage: false,
  isLabelInfo2Positive: false,
  isLabelInfo5Positive: false,
  isBBEDashboard: false,
  isInventory: false,
  isCancelRequest: false,
  showBorder: false,
  iconAfterLabel: false,
  className: '',
  CompanyName: '',
  label: '',
  statusLabelColor: '',
  labelInfo: '',
  label1: '',
  labelInfo1: '',
  sublabel: '',
  sublabel1: '',
  label2: '',
  labelInfo2: '',
  label3: '',
  labelInfo3: '',
  label4: '',
  labelInfo4: '',
  label5: '',
  labelInfo5: '',
  label6: '',
  labelInfo6: '',
  label7: '',
  labelInfo7: '',
  label8: '',
  labelInfo8: '',
  invoiceType: '',
  invoiceId: '',
  status: '',
  statusColor: '',
  icon: '',
  marketplaces: '',
  mainLabel: '',
  copyText: '',
  statusIcon: '',
  onClick: () => {},
  onColumnClick: () => {},
};

TableMobileView.propTypes = {
  isColumnOnClick: bool,
  isShowCopyIcon: bool,
  isShowPercentage: bool,
  isLabelInfo2Positive: bool,
  isLabelInfo5Positive: bool,
  isBBEDashboard: bool,
  isInventory: bool,
  isCancelRequest: bool,
  showBorder: bool,
  iconAfterLabel: bool,
  className: string,
  CompanyName: string,
  label: string,
  statusLabelColor: string,
  labelInfo: string,
  label1: string,
  labelInfo1: string,
  sublabel: string,
  sublabel1: string,
  label2: string,
  labelInfo2: string,
  label3: string,
  labelInfo3: string,
  label4: string,
  labelInfo4: string,
  label5: string,
  labelInfo5: string,
  label6: string,
  labelInfo6: string,
  label7: string,
  labelInfo7: string,
  label8: string,
  labelInfo8: string,
  invoiceType: string,
  invoiceId: string,
  status: string,
  statusColor: string,
  icon: string,
  marketplaces: string,
  mainLabel: string,
  copyText: string,
  statusIcon: string,
  onClick: func,
  onColumnClick: func,
};
